<template>
  <div class="d-flex flex-column align-items-center mt-32">
    
    <div v-if="!shop_order">
      <memlist-spinner/>
    </div>
    <div v-else>
      <PaymentStatusComponent 
        :order="shop_order"
      />
    </div>
    
  </div>
</template>

<script>
import axios from 'axios';
import PaymentStatusComponent from '@/view/pages/members/payment/PaymentStatusComponent.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: 'ResumePaymentSession',
  mixins: [ toasts ],
  props: [],
  components: {
    PaymentStatusComponent
  },
  data() {
    return {
      is_paid_in_full: false,
      shop_order_id: null,
      token: null,
      error: null,
      shop_order: null
    };
  },
  async mounted() {
    this.token = this.$route.params.token;
    this.shop_order_id = this.$route.params.shop_order_id;
    
    this.shop_order = await this.get_order(this.token, this.shop_order_id);

    if (!this.shop_order) {
      this.error = true;
    }
    else {
      if (this.shop_order.status === 'CANCELLED') {
        await this.resume_order(this.token, this.shop_order.shop_order_id);
        this.$router.push(`/select-payment/${this.token}/${this.shop_order.shop_order_id}`);
      }

      if (this.shop_order.payment_status !== 'PAID_IN_FULL') {
        this.$router.push(`/select-payment/${this.token}/${this.shop_order.shop_order_id}`);
      }
       
    }
  },
  watch: {},
  methods: {

    async resume_order(token, shop_order_id) {
      try {
        const res = await axios.post(`/shop_order/resume/token/${token}/${shop_order_id}`, {});

        if (res.status === 200) {

          if (res.data.error) {
            this.error = res.data.error;
          }

          return res.data;
        }
      }
      catch (err) {
        console.error('resume_order error', err);
      }

      throw `unable to resume order`;
    },
    async get_order(token, shop_order_id) {
      try {
        const res = await axios.get(`/shop_order/token/${token}/${shop_order_id}`);

        if (res.status === 200) {

          if (res.data.error) {
            this.error = res.data.error;
          }

          return res.data;
        }
      }
      catch (err) {
        console.error('get_order error', err);
      }

      throw `unable to get order`;
    },

  }
};
</script>
